__turbopack_context__.v({
  "banner": "ChangeLogDialog-module__R5Rhkq__banner",
  "card": "ChangeLogDialog-module__R5Rhkq__card",
  "cardsGrid": "ChangeLogDialog-module__R5Rhkq__cardsGrid",
  "categoryHasNewItems": "ChangeLogDialog-module__R5Rhkq__categoryHasNewItems",
  "categoryItem": "ChangeLogDialog-module__R5Rhkq__categoryItem",
  "dialog": "ChangeLogDialog-module__R5Rhkq__dialog",
  "navItems": "ChangeLogDialog-module__R5Rhkq__navItems",
  "subtleGlow": "ChangeLogDialog-module__R5Rhkq__subtleGlow",
});
